import { useMutation, useQuery } from "@apollo/client";
import * as React from "react";
import { getUserId, getBrand } from "../../helpers/functions";
import Button from "../Button/button.component";
import LoadingSpinner from "../LoadingSpinner/loading-spinner.component";
import { GET_API_KEYS, SET_API_KEY_DISABLED, SET_API_KEY_ENABLED, DELETE_API_KEY, ADD_API_KEY } from "./query";
import { Container } from "./styles";
import Toggle from "react-toggle";
import Modal from "react-modal";
import { useToasts } from "react-toast-notifications";
import { ModalButton, ModalHeader, ModalButtonContainer, ModalDescription } from "../MsgBoxModal/styles";

const APIKeysTable = () => {

	const [isOpen, setIsOpen] = React.useState(false)
	const [key, setKey] = React.useState("")

	const { addToast } = useToasts();

	const processKey = (key) => {
		if (!key || key.length < 5) return key;
		return key.slice(0, 5) + "*".repeat(key.length - 5);
	}

	const { data, loading, error } = useQuery(GET_API_KEYS, {
		variables: {
			userId: getUserId(),
		},
		fetchPolicy: "network-only",
	});

	const [setAPIKeyIdEnabled, { loading: setAPIKeyLoading }] = useMutation(
		SET_API_KEY_ENABLED,
		{
			refetchQueries: [
				{
					query: GET_API_KEYS,
					variables: {
						userId: getUserId(),
					},
				},
			],
		}
	);

	const [setAPIKeyDisabled, { loading: APIKeyloading }] = useMutation(
		SET_API_KEY_DISABLED,
		{
			refetchQueries: [
				{
					query: GET_API_KEYS,
					variables: {
						userId: getUserId(),
					},
				},
			],
		}
	);

	const [deleteAPIKey, { loading: deleteLoading }] = useMutation(DELETE_API_KEY, {
		refetchQueries: [
			{ query: GET_API_KEYS, variables: { userId: getUserId() } },
		],
	});

	const [addAPIKey, { loading: addLoading }] = useMutation(ADD_API_KEY, {
		refetchQueries: [
			{
				query: GET_API_KEYS,
			},
		],
	});

	const handleClose = () => {
		setIsOpen(false);
	};

	const handleOpen = () => {
		setIsOpen(true);
	};

	const handleSetAPIKey = async (id, enabled) => {
		if(enabled){
			await setAPIKeyIdEnabled({
				variables: {
					id
				},
			});
		} else {
			const confirmed = window.confirm("Are you sure you want to disable this API key? Any integration using this key will stop working");
			if (!confirmed) return;
			await setAPIKeyDisabled({
				variables: {
					id
				},
			});
		}
	};

	const handleDelete = async (id) => {
		const confirmed = window.confirm("Are you sure you want to delete this API key? Any integration using this key will stop working");
		if (!confirmed) return;
		await deleteAPIKey({ variables: { id } });
	};

	if (loading) return <LoadingSpinner />;

	if (error) {
		return <p>oops... something went wrong</p>;
	}
	
	const addKey = async () => {
		const brand = getBrand();
		let key = "";
		if (brand === "Whatex") {
			key += "we-";
		} else if (brand === "OmniChat") {
			key += "oc-";
		} else {
			key += "mb-";
		}
		key += crypto.randomUUID();
		setKey(key);

		try {
			await addAPIKey({
				variables: {
					key
				},
			});

			handleOpen();

		} catch (e) {
			addToast("Something went wrong", {
				appearance: "error",
				autoDismiss: true,
			});
		}
	};

	const copyKey = () => {
		navigator.clipboard.writeText(key)
		alert("Copied to clipboard")
	}

	return (
		<Container>
			<table>
				<tr>
					<th>Key</th>
					<th>Enabled</th>
					<th>Actions</th>
				</tr>
				{data.msgbox_APIKey.map((key) => (
					<tr key={key.APIKeyId}> 
						<td>
							<p>{processKey(key.Key)}</p>
						</td>
						<td>
							<Toggle
								id={key.APIKeyId}
								onChange={async () => {
									await handleSetAPIKey(
										key.APIKeyId,
										!key.Enabled
									);
								}}
								disabled={setAPIKeyLoading || APIKeyloading}
								name="enabled"
								checked={key.Enabled === true}
							/>
						</td>
						<td>
							<button
								aria-label="Delete API key"
								title="Delete"
								onClick={() => handleDelete(key.APIKeyId)}
								style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 6, color: '#c62828', marginLeft: 6 }}
								disabled={deleteLoading}
							>
								<i className="fas fa-trash" />
							</button>
						</td>
					</tr>
				))}
			</table>

			<Button
				primary
				buttonName="Add another API key"
				onClick={addKey}
				disabled={addLoading}
			/>
			<Modal
				isOpen={isOpen}
				onRequestClose={handleClose}
				style={{
					content: {
						overflow: "visible",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
					},
					overlay: {
						backgroundColor: "rgba(0,0,0,0.7)",
					},
				}}
			>
				<ModalHeader><h2>API Key Sucessfully Created</h2></ModalHeader>
				<ModalDescription>
					<p>Your API Key has been sucessfully created. This is the only time you will be able to view your key. Please use the button below or copy your key and save it before closing this window.</p>
				</ModalDescription>
				<p>Your new key: {key}</p>
				<ModalButtonContainer>
					<ModalButton
						type="button"
						buttonName="Copy key"
						onClick={copyKey}
						primary
					/>
					<ModalButton
						type="button"
						buttonName="Close"
						onClick={handleClose}
					/>
				</ModalButtonContainer>
			</Modal>
		</Container>
	);
};

export default APIKeysTable;
